import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";

import { useStyles } from "./ManageFee.css";
import AdminHeader from "../../../../Components/NavBar/Admin/AdminHeader/AdminHeader";
import FeeGroupFilterForm from "./FeeGroupFilterForm/FeeGroupFilterForm";
import CustomEmptyMessage from "../../../../Components/CustomEmptyMessage/CustomEmptyMessage";
import CustomTableHead from "../../../../Components/Table/CustomTableHeader/CustomTableHeader";
import ManageFeeBody from "./ManageFeeBody/ManageFeeBody";
import ManageFeeDetails from "./ManageFeeDetails/ManageFeeDetails";
import { url } from "../../../../Config/Config";
import Axios from "axios";
import { connect } from "react-redux";
import { getAdminRefreshToken } from "../../../../Redux/Actions/actions";
import PageTitle from "../../../../Components/PageTitle/PageTitle";
import CustomBreadCrumbs from "../../../../Components/CustomBreadCrumbs/CustomBreadCrumbs";

class ManageFee extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        session: new Date().getFullYear(),
        class: "",
        faculty: "",
        group: "",
        section: "",
      },
      column: [
        { name: "S.N." },
        { name: "Student Name" },
        { name: "Class" },
        { name: "Faculty" },
        { name: "Group" },
        { name: "Section" },
        { name: "Actions" },
      ],
      isEmpty: true,
      detailStatus: false,
      studentFeeId: "",
      detailData: {},
      studentList: [],
      initialFeeGroup: [],
    };
  }

  handleChange = (e) => {
    this.setState({
      data: {
        ...this.state.data,
        [e.target.name]: e.target.value,
      },
    });
  };

  handleChangeClass = (e) => {
    this.setState({
      data: {
        ...this.state.data,
        class: e.target.value,
        faculty: "",
        group: "",
        section: "",
      },
    });
  };

  handleSubmit = (e, students, feeGroup) => {
    e.preventDefault();
    if (students.length === 0 || feeGroup.length === 0) {
      this.setState({
        isEmpty: true,
      });
    } else {
      this.setState({
        studentList: students,
        initialFeeGroup: feeGroup,
        isEmpty: false,
      });
    }
  };

  filterData = (data) => {
    let changedData = data;
    if (changedData.faculty === "") {
      delete changedData.faculty;
    }
    if (changedData.group === "") {
      delete changedData.group;
    }
    return changedData;
  };

  checkData = (data, detailData) => {
    let toReturn = data.filter((filterData) => {
      return filterData.studentId.indexOf(detailData._id) !== -1;
    });
    if (toReturn.length !== 0) {
      return toReturn[0]._id;
    } else {
      return false;
    }
  };

  handleShowDetails = async (detailData) => {
    let data = {
      session: detailData.currentSession,
      admissionId: detailData.admissionId,
      studentId: detailData._id,
      studentName: detailData.firstName + " " + detailData.lastName,
      studentClass: detailData.studentClass,
      faculty: detailData.faculty ? detailData.faculty : "",
      group: detailData.group ? detailData.group : "",
      section: detailData.section ? detailData.section : "",
    };
    let changedData = this.filterData(data);
    try {
      const getResponse = await Axios.get(`${url}/api/student-fees`, {
        headers: {
          Authorization: `Bearer ${this.props.adminToken}`,
        },
      });
      let isPresent = this.checkData(getResponse.data.studentFees, detailData);
      if (isPresent) {
        this.setState({ studentFeeId: isPresent, detailStatus: true });
      } else {
        const response = await Axios.post(
          `${url}/api/student-fees`,
          changedData,
          {
            headers: {
              Authorization: `Bearer ${this.props.adminToken}`,
            },
          }
        );
        if (response.data.studentFeeId) {
          this.setState({
            studentFeeId: response.data.studentFeeId,
            detailStatus: true,
          });
        }
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.handleShowDetails(detailData);
      }
    }
  };

  handleCancelShowDetails = () => {
    this.setState({
      detailStatus: false,
    });
  };

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <AdminHeader />
        <div className={classes.content}>
          <div className={classes.toolbar} />
          <CustomBreadCrumbs url={this.props.match.url} />
          <PageTitle title="Manage Fee" refreshUrl={this.props.match.url} />

          <FeeGroupFilterForm
            buttonLabel="Get Students"
            data={this.state.data}
            handleChangeClass={this.handleChangeClass}
            handleChange={this.handleChange}
            handleSubmit={this.handleSubmit}
          />
          <br />
          {this.state.isEmpty === false ? (
            this.state.detailStatus === false ? (
              <TableContainer>
                <Table>
                  <CustomTableHead column={this.state.column} />

                  <TableBody>
                    {this.state.studentList.map((student, index) => (
                      <ManageFeeBody
                        key={index}
                        index={index}
                        data={student}
                        handleShowDetails={this.handleShowDetails}
                      />
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              <ManageFeeDetails
                studentFeeId={this.state.studentFeeId}
                data={this.state.detailData}
                initialFeeGroup={this.state.initialFeeGroup}
                handleCancelShowDetails={this.handleCancelShowDetails}
              />
            )
          ) : (
            <CustomEmptyMessage
              description={
                <div>
                  <div>Please fill up the above form.</div>
                  <div>
                    Even after filling form if this shows, then either the
                    student list is empty or fee group is empty for this class
                  </div>
                </div>
              }
            />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(ManageFee));
